import LandingLayout from '@/components/landing/home/LandingLayout';
import Head from 'next/head';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { clearRoomQuery, getRoomsList, setRoomQueryData } from '../../actions/room';
import RoomsGrid from '../../components/layout/room/landing/RoomsGrid';

const RoomPage = () => {
  const dispatch = useDispatch();
  const query = useSelector((state: any) => state.roomReducer.query.roomList);
  const rooms = useSelector((state: any) => state.roomReducer?.roomList);
  const meta = useSelector((state: any) => state.roomReducer?.roomList.meta);

  useEffect(() => {
    dispatch(clearRoomQuery());
  }, []);

  useEffect(() => {
    dispatch(getRoomsList(query));
  }, [JSON.stringify([query.page, query.per_page, query.search])]);

  const handlePagination = (page: number, per_page: number) => {
    dispatch(
      setRoomQueryData({ name: 'roomList', value: { ...query, page, per_page } })
    );
  };

  return (
    <>
      <Head>
        <title>Rooms List | Learnsic</title>
      </Head>
      <LandingLayout>
        <RoomsGrid
          rooms={rooms}
          total={meta?.total}
          loading={rooms?.loading}
          handlePagination={handlePagination}
        />
      </LandingLayout>
    </>
  );
};

export default RoomPage;
